export const STATUS = {
  da_fare: {
    key: "da_fare",
    label: "Da fare",
    bg: "rgba(59, 130, 246, 0.14)",
    border: "rgba(59, 130, 246, 0.35)",
    text: "#60A5FA",
  },
  in_corso: {
    key: "in_corso",
    label: "In corso",
    bg: "rgba(245, 158, 11, 0.14)",
    border: "rgba(245, 158, 11, 0.35)",
    text: "#FBBF24",
  },
  completato: {
    key: "completato",
    label: "Completato",
    bg: "rgba(16, 185, 129, 0.14)",
    border: "rgba(16, 185, 129, 0.35)",
    text: "#34D399",
  },
};

export const STATUS_ORDER = ["da_fare", "in_corso", "completato"];

export function initials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

export function isToday(iso) {
  return iso === todayISO();
}

export function isOverdue(iso) {
  if (!iso) return false;
  return iso < todayISO();
}
